// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#modal-root {
    width: 100%;
    height: 100%;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
}
#modal {
    position: absolute;
    top: 35%;
    z-index: 10;
    padding: 25px 20px;
    border: 1px rgba(0, 0, 0, 0.25) solid;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.35);
    border-radius: 6px;
    background-color: white;
    flex-direction: column;
    gap: 20px;
    font-size: 1rem;
    animation: fadein 0.5s;
}
.modal-form {
    width: 100%;
}
@keyframes fadein {
    from {
        opacity: 0;
    } to {
        opacity: 1;
    }
}
.modal-root {
    z-index: 5;
}
.modal {
    display: flex;
}
.modal-body {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
.modal-field-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 10px;
}
#modal input {
    flex: auto;
    /* font-family: 'Poppins Medium'; */
    font-size: 1rem;
    padding: 2px 5px;
    border-radius: 6px;
    color: rgba(128, 128, 128, 0.9);
}
#modal input:focus {
    outline-width: 0;
}
#modal-btn-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
#modal-btn-container button {
    border: 0;
}

#task-name-input {
    appearance: none;
    border: 0;
    width: 100%;
}
.datetime-input {
    border: 1px rgba(0, 0, 0, 0.3) solid;
}
#date-input {
    width: auto;
}
#time-input {
    width: auto;
}
.modal-subtitle {
    font-size: 1rem;
    /* font-family: 'Poppins Medium'; */
    color: rgba(95, 95, 95, 0.75);
    margin-right: 10%;
}
@media only screen and (max-width: 600px) {
    .modal-subtitle {
        margin: 0;
    }
}
#priority-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1.2rem;
}
.priority-radio-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: none;
    gap: 3px;
}
.priority-radio, .priority-radio-label {
    cursor: pointer;
}
.priority-radio-label {
    font-size: 0.9rem;
    /* font-family: 'Poppins Medium'; */
    color: rgb(85, 85, 85);
}
#modal-submit {
    font-size: 16px;
    background-color: white;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 6px;
    transition: background-color 300ms;
    background-color: rgb(190, 127, 10);
    color: white;
    /* font-family: 'Poppins Medium'; */
    font-size: 0.9rem;
}
@media (min-width:1281px) {
    /* hi-res laptops and desktops */
    #modal input{
        font-size: 1.1rem;
    }
    .modal-subtitle {
        font-size: 1.1rem;
    }
    .priority-radio {
        width: 16px;
        height: 16px;
    }
    .priority-radio-label {
        font-size: 1.1rem;
    }
    #modal-submit {
        font-size: 1.1rem;
    }
}
#modal-submit:hover {
    background-color: rgb(190, 127, 10, 0.6);
    /* background-color: rgba(145, 116, 62, 0.781); */
}
#modal-submit:active {
    transition: background-color 300ms;
    background-color: rgb(190, 127, 10);
}
.empty-field {
    border: 2px red solid !important;
}
.checked-task {
    text-decoration: line-through !important;
}
.high-priority-task {

}`, "",{"version":3,"sources":["webpack://./src/styles/modal.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI;QACI,UAAU;IACd,EAAE;QACE,UAAU;IACd;AACJ;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;AACb;AACA;IACI,UAAU;IACV,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;AACnC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,WAAW;AACf;AACA;IACI,oCAAoC;AACxC;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,mCAAmC;IACnC,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI;QACI,SAAS;IACb;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;AACZ;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;IAClC,mCAAmC;IACnC,YAAY;IACZ,mCAAmC;IACnC,iBAAiB;AACrB;AACA;IACI,gCAAgC;IAChC;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,wCAAwC;IACxC,iDAAiD;AACrD;AACA;IACI,kCAAkC;IAClC,mCAAmC;AACvC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,wCAAwC;AAC5C;AACA;;AAEA","sourcesContent":["#modal-root {\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n#modal {\n    position: absolute;\n    top: 35%;\n    z-index: 10;\n    padding: 25px 20px;\n    border: 1px rgba(0, 0, 0, 0.25) solid;\n    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.35);\n    border-radius: 6px;\n    background-color: white;\n    flex-direction: column;\n    gap: 20px;\n    font-size: 1rem;\n    animation: fadein 0.5s;\n}\n.modal-form {\n    width: 100%;\n}\n@keyframes fadein {\n    from {\n        opacity: 0;\n    } to {\n        opacity: 1;\n    }\n}\n.modal-root {\n    z-index: 5;\n}\n.modal {\n    display: flex;\n}\n.modal-body {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n.modal-field-container {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    gap: 10px;\n}\n#modal input {\n    flex: auto;\n    /* font-family: 'Poppins Medium'; */\n    font-size: 1rem;\n    padding: 2px 5px;\n    border-radius: 6px;\n    color: rgba(128, 128, 128, 0.9);\n}\n#modal input:focus {\n    outline-width: 0;\n}\n#modal-btn-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n#modal-btn-container button {\n    border: 0;\n}\n\n#task-name-input {\n    appearance: none;\n    border: 0;\n    width: 100%;\n}\n.datetime-input {\n    border: 1px rgba(0, 0, 0, 0.3) solid;\n}\n#date-input {\n    width: auto;\n}\n#time-input {\n    width: auto;\n}\n.modal-subtitle {\n    font-size: 1rem;\n    /* font-family: 'Poppins Medium'; */\n    color: rgba(95, 95, 95, 0.75);\n    margin-right: 10%;\n}\n@media only screen and (max-width: 600px) {\n    .modal-subtitle {\n        margin: 0;\n    }\n}\n#priority-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 1.2rem;\n}\n.priority-radio-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    box-shadow: none;\n    gap: 3px;\n}\n.priority-radio, .priority-radio-label {\n    cursor: pointer;\n}\n.priority-radio-label {\n    font-size: 0.9rem;\n    /* font-family: 'Poppins Medium'; */\n    color: rgb(85, 85, 85);\n}\n#modal-submit {\n    font-size: 16px;\n    background-color: white;\n    cursor: pointer;\n    padding: 5px 10px;\n    border-radius: 6px;\n    transition: background-color 300ms;\n    background-color: rgb(190, 127, 10);\n    color: white;\n    /* font-family: 'Poppins Medium'; */\n    font-size: 0.9rem;\n}\n@media (min-width:1281px) {\n    /* hi-res laptops and desktops */\n    #modal input{\n        font-size: 1.1rem;\n    }\n    .modal-subtitle {\n        font-size: 1.1rem;\n    }\n    .priority-radio {\n        width: 16px;\n        height: 16px;\n    }\n    .priority-radio-label {\n        font-size: 1.1rem;\n    }\n    #modal-submit {\n        font-size: 1.1rem;\n    }\n}\n#modal-submit:hover {\n    background-color: rgb(190, 127, 10, 0.6);\n    /* background-color: rgba(145, 116, 62, 0.781); */\n}\n#modal-submit:active {\n    transition: background-color 300ms;\n    background-color: rgb(190, 127, 10);\n}\n.empty-field {\n    border: 2px red solid !important;\n}\n.checked-task {\n    text-decoration: line-through !important;\n}\n.high-priority-task {\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
